// const baseUrl = "http://13.232.47.157:8082";
const baseUrl = "https://xflix-rishi.herokuapp.com";
export default baseUrl;